import {
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
} from './UShort.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { containscs3vsq7ynpxl as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _UShortArray___init__impl__9b26ef(storage) {
  return storage;
}
function _UShortArray___get_storage__impl__t2jpv5($this) {
  return $this;
}
function _UShortArray___init__impl__9b26ef_0(size) {
  return _UShortArray___init__impl__9b26ef(new Int16Array(size));
}
function UShortArray__get_impl_fnbhmx($this, index) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = _UShortArray___get_storage__impl__t2jpv5($this)[index];
  return _UShort___init__impl__jigrne(this_0);
}
function UShortArray__set_impl_6d8whp($this, index, value) {
  var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
  // Inline function 'kotlin.UShort.toShort' call
  tmp[index] = _UShort___get_data__impl__g0245(value);
}
function _UShortArray___get_size__impl__jqto1b($this) {
  return _UShortArray___get_storage__impl__t2jpv5($this).length;
}
function UShortArray__iterator_impl_ktpenn($this) {
  return new (Iterator())(_UShortArray___get_storage__impl__t2jpv5($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.array_1 = array;
        this.index_1 = 0;
      }
      hasNext_bitz1p_k$() {
        return this.index_1 < this.array_1.length;
      }
      next_csnf8m_k$() {
        var tmp;
        if (this.index_1 < this.array_1.length) {
          var _unary__edvuaz = this.index_1;
          this.index_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toUShort' call
          var this_0 = this.array_1[_unary__edvuaz];
          tmp = _UShort___init__impl__jigrne(this_0);
        } else {
          throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$(this.index_1.toString());
        }
        return tmp;
      }
      next_20eer_k$() {
        return new (UShort())(this.next_csnf8m_k$());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function UShortArray__contains_impl_vo7k3g($this, element) {
  var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
  // Inline function 'kotlin.UShort.toShort' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(element);
  return contains(tmp, tmp$ret$0);
}
function UShortArray__contains_impl_vo7k3g_0($this, element) {
  if (!(element instanceof UShort()))
    return false;
  return UShortArray__contains_impl_vo7k3g($this.storage_1, element instanceof UShort() ? element.data_1 : THROW_CCE());
}
function UShortArray__isEmpty_impl_cdd9l0($this) {
  return _UShortArray___get_storage__impl__t2jpv5($this).length === 0;
}
function UShortArray__toString_impl_omz03z($this) {
  return 'UShortArray(storage=' + toString($this) + ')';
}
function UShortArray__hashCode_impl_2vt3b4($this) {
  return hashCode($this);
}
function UShortArray__equals_impl_tyc3mk($this, other) {
  if (!(other instanceof UShortArray()))
    return false;
  var tmp0_other_with_cast = other.storage_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var UShortArrayClass;
function UShortArray() {
  if (UShortArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.storage_1 = storage;
      }
      get_size_woubt6_k$() {
        return _UShortArray___get_size__impl__jqto1b(this.storage_1);
      }
      iterator_jk1svi_k$() {
        return UShortArray__iterator_impl_ktpenn(this.storage_1);
      }
      contains_dxk1pv_k$(element) {
        return UShortArray__contains_impl_vo7k3g(this.storage_1, element);
      }
      contains_aljjnj_k$(element) {
        return UShortArray__contains_impl_vo7k3g_0(this, element);
      }
      isEmpty_y1axqb_k$() {
        return UShortArray__isEmpty_impl_cdd9l0(this.storage_1);
      }
      toString() {
        return UShortArray__toString_impl_omz03z(this.storage_1);
      }
      hashCode() {
        return UShortArray__hashCode_impl_2vt3b4(this.storage_1);
      }
      equals(other) {
        return UShortArray__equals_impl_tyc3mk(this.storage_1, other);
      }
    }
    initMetadataForClass($, 'UShortArray', VOID, VOID, [Collection()]);
    UShortArrayClass = $;
  }
  return UShortArrayClass;
}
//region block: exports
export {
  _UShortArray___init__impl__9b26ef_0 as _UShortArray___init__impl__9b26eftay922a1mq7k,
  _UShortArray___init__impl__9b26ef as _UShortArray___init__impl__9b26ef35x6jp7uuoumr,
  UShortArray__get_impl_fnbhmx as UShortArray__get_impl_fnbhmx2opdoe19gpa9f,
  UShortArray__set_impl_6d8whp as UShortArray__set_impl_6d8whp2ks3cfavbrzax,
  _UShortArray___get_size__impl__jqto1b as _UShortArray___get_size__impl__jqto1b2ufu97m66fe6o,
  _UShortArray___get_storage__impl__t2jpv5 as _UShortArray___get_storage__impl__t2jpv5vwyttef17wd6,
  UShortArray as UShortArray11avpmknxdgvv,
};
//endregion

//# sourceMappingURL=UShortArray.mjs.map
